import { getEndpoint, getHeaders } from '../../../helpers/endpoint';

export const REQUEST_FETCH_STATS_BADGES = 'REQUEST_FETCH_STATS_BADGES';
export const SUCCESS_FETCH_STATS_BADGES = 'SUCCESS_FETCH_STATS_BADGES';
export const FAIL_FETCH_STATS_BADGES = 'FAIL_FETCH_STATS_BADGES';

export const fetchStatsBadges = (payload, callbacks) => {
    const { onError, onRequest, onSuccess } = callbacks;
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_STATS_BADGES, payload });
        if (onRequest) onRequest(payload);

        fetch(getEndpoint('fetchStatsBadges', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication),
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({ type: FAIL_FETCH_STATS_BADGES });
                else dispatch({ type: SUCCESS_FETCH_STATS_BADGES, data });

                if (onSuccess) onSuccess(data, payload);
            })
            .catch((error, type = FAIL_FETCH_STATS_BADGES) => {
                if (onError) onError(error, type);
                dispatch({ type, error });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/entities/statistics/badges.js